import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useGetQRCodeByUrl } from "../../hooks/qrCodeHooks";
export const RedirectQRPage = () => {
    const navigate = useNavigate();
    const url = window.location.href;
    console.log("RedirectQRPage accessed with URL:", url);
    const number = url.split("/").pop();
    const { data, isSuccess } = useGetQRCodeByUrl(url);

    // if (isSuccess && data) {
    //     navigate(
    //         `/companies/${data.companyId}/inventories/${data.inventoryId}/products/${data.productId}`,
    //     );
    // } else {
    //     navigate(`/not-found`, {
    //         state: {
    //             error: "QR code not found or invalid.",
    //         },
    //     });
    // }
    useEffect(() => {
        if (isSuccess && data) {
            console.log("Redirecting to product page:", {
                companyId: data.companyId,
                inventoryId: data.inventoryId,
                productId: data.productId,
            });
            navigate(
                `/companies/${data.companyId}/inventories/${data.inventoryId}/products/${data.productId}`,
            );
        } else {
            console.log("QR code not found or invalid:", data);
            navigate(`/not-found`, {
                state: {
                    error: "QR code not found or invalid.",
                },
            });
        }
    }, [isSuccess, data]);

    return <>Redirecting...</>;
};
